var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharingScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.2C0 4.0799 0 3.51984 0.217987 3.09202C0.409734 2.71569 0.715695 2.40973 1.09202 2.21799C1.51984 2 2.0799 2 3.2 2H12.8C13.9201 2 14.4802 2 14.908 2.21799C15.2843 2.40973 15.5903 2.71569 15.782 3.09202C16 3.51984 16 4.0799 16 5.2V10.8C16 11.9201 16 12.4802 15.782 12.908C15.5903 13.2843 15.2843 13.5903 14.908 13.782C14.4802 14 13.9201 14 12.8 14H3.2C2.0799 14 1.51984 14 1.09202 13.782C0.715695 13.5903 0.409734 13.2843 0.217987 12.908C0 12.4802 0 11.9201 0 10.8V5.2ZM8.625 7.00888L9.55806 7.94194C9.80214 8.18602 10.1979 8.18602 10.4419 7.94194C10.686 7.69786 10.686 7.30214 10.4419 7.05806L8.44194 5.05806C8.19786 4.81398 7.80214 4.81398 7.55806 5.05806L5.55806 7.05806C5.31398 7.30214 5.31398 7.69786 5.55806 7.94194C5.80214 8.18602 6.19786 8.18602 6.44194 7.94194L7.375 7.00888V10.5C7.375 10.8452 7.65482 11.125 8 11.125C8.34518 11.125 8.625 10.8452 8.625 10.5V7.00888Z",
    fill: "#00A832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharingScreen);
export default __webpack_public_path__ + "static/media/sharing-screen.77982892be8691911bd9aee1e7e8e128.svg";
export { ForwardRef as ReactComponent };